/* eslint-disable camelcase */
import axios from "axios";
import { notificationReadUpdateRequest } from "../redux/actions";

const getNotifications = () =>
  axios.get(`https://notification-centre.azurewebsites.net/notifications`);

const getReadDate = () =>
  axios.get(`https://notification-centre.azurewebsites.net/user/lastread`);

const updateReadDate = () => {
  notificationReadUpdateRequest();
};

export { getNotifications, getReadDate, updateReadDate };
